<div class="slider">
  <input type="range" [min]="realMin" [max]="realMax" [(ngModel)]="value" [step]="step" (ngModelChange)="onChange(value)">
  <span class="value" *ngIf="value < min">{{snapMin}}</span>
  <span class="value" *ngIf="value > max">{{snapMax}}</span>
  <span class="value" *ngIf="value >= min && value <= max">
    <ng-container *ngIf="!textOverride">{{value}}%</ng-container>
    <ng-container *ngIf="textOverride">{{textOverride[value] || value}}</ng-container>
  </span>
</div>
